module.exports = __webpack_public_path__ + "img/photo-10.56da40d4.jpg";